<!-- eslint-disable prettier/prettier -->
<style lang="less">
/* The max width is dependant on the container (more info below) */
.popover {
    max-width: 300px !important;
    /* Max Width of the popover (depending on the container!) */
    width: 100%;
}

//  toast notifications style

.vue-notification-wrapper {
    background: transparent;
}

.vue-app-notification {
    padding: 10px;
    margin: 8px;
    margin-bottom: 0px;
    // font-family: 'europa';
    border-radius: 7px;
    font-size: 13px;

    color: #212529;
    background: #ffffff;
    // border-left: 3px solid #ffffff;
    // border-left-color: #0055B8;
    color: #000;
    // border: none !important;

    &.warn {
        background: var(--c-lemon);
    }

    &.error {
        background: var(--c-error);
    }

    &.success {
        background: var(--c-crocodile);
    }
}

.vue-notification-group {
    top: 70px !important;
}

//is needed for deprecated search inputs that do not use CoInput component
.search-bar-wrapper {
    max-width: 1200px;
    padding-left: 10px;
    // border: 1px solid var(--c-primary);
    overflow: hidden;
    background: white;

    .b-icon {
        color: var(--c-darkgrey);
        margin-top: 1px;
        @media (max-width: 355px) {
            display: none !important;
        }
        // transform: scale(.8);
        &.search-focus {
            color: var(--c-primary);
        }
    }

    @media (min-width: 768px) {
        width: calc(100% - 270px);
    }
    @media (min-width: 1290px) {
        width: calc(100% - 520px);
    }
}

input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
}
</style>
<template>
    <div class="px-0 animate-blur" :path="path" :class="{ 'modal-blur': modalBlur }">
        <CoTopNavBarWeb
            v-if="!isInMobile"
            :spaceName="this.$store.state.space.Name"
            :logoURL="this.$store.state.space.LogoURL"
            :me="this.$store.state.me"
            :supportURL="SupportURL"
            :showUpgradeBar="showUpgradeBar"
            @createpost="startPostCreation"
            @pausenotificationsclick="showPauseNotificationsModal"
            @unpausenotificationsclick="showDeletePauseNotificationsModal"
        />
        <!-- global admin alerts for limits and payment issues -->
        <CoAdminAlert v-if="!isInMobile" />
        <!-- spacer is necessary for vertical spacing for all router views not using UserMainGrid.vue -->
        <div class="spacer"></div>
        <router-view ref="routerview" />
        <CoIslandCreateButton
            v-if="showIslandButton"
            @createPost="startPostCreation"
            @createEvent="$router.push('/events/create')"
            @createMarketItem="$router.push('/submit-job')"
            @createPage="$router.push('/create/page')"
        />

        <div class="position-relative">
            <IntroModal
                :intro="this.$store.state.space['Intro']"
                v-if="
                    this.$store &&
                    this.$store.state &&
                    this.$store.state.space &&
                    this.$store.state.space.Intro &&
                    this.$route.name === 'Timeline'
                "
                @close="emitEventToIntercom"
            ></IntroModal>
            <IntroReminder
                :intro="this.$store.state.space['Intro']"
                v-if="this.$store.state.space['Intro'] != null"
            ></IntroReminder>
        </div>

        <!-- pause notifications modal -->
        <b-modal
            id="pause-notificaions"
            ref="pause-notificaions"
            size="md"
            :title="$t('labels.notificationspause')"
            :ok-title="$t('labels.pause')"
            :cancel-title="$t('labels.cancel')"
            ok-variant="primary"
            @ok="setNotificationPause"
            centered
            no-fade
        >
            <b-overlay>
                <div class="mb-4">
                    <label :for="`picker-date`" class="label-align">{{ $t('labels.enddate') }}</label>
                    <b-form-datepicker
                        :label-no-date-selected="$t('labels.dateempty')"
                        :placeholder="$t('placeholders.date')"
                        :id="`picker-date`"
                        v-model="pauseUntil.date"
                        class="rounded-pill"
                    ></b-form-datepicker>
                </div>
                <div class="mb-4">
                    <label :for="`timepicker-from`" class="label-align">{{ $t('labels.time') }}</label>
                    <b-form-timepicker
                        :id="`timepicker-from`"
                        v-model="pauseUntil.time"
                        :locale="$language"
                        :hour12="false"
                        class="rounded-pill"
                        aria-label="from"
                    ></b-form-timepicker>
                </div>
                <label for="message" class="label-align">{{ $t('labels.awaynotice') }}</label>
                <CoEditor
                    id="message"
                    :placeholder="$t('placeholders.optional')"
                    :hideActions="true"
                    :hideSendButton="true"
                    variant="full"
                    @input="pauseUntil.message = $event.Html"
                />
            </b-overlay>
        </b-modal>

        <b-modal
            id="delete-pause-notificaions"
            ref="delete-pause-notificaions"
            size="md"
            :title="$t('labels.notificationspaused')"
            :ok-title="$t('labels.delete')"
            :ok-cancel="$t('labels.cancel')"
            ok-variant="danger"
            @ok="removeNotificationPause"
            centered
            no-fade
        >
            <b-overlay>
                <h3>{{ $t('labels.enddate') }}</h3>
                <h3>
                    <coDate :date="this.$store.state.me['NotificationsOffUntill']" format="exact" />
                </h3>
                <div class="mt-3">
                    <h3>{{ $t('labels.awaynotice') }}</h3>
                    <p
                        v-if="this.$store.state.me['NotificationsOffMessage']"
                        v-html="this.$store.state.me['NotificationsOffMessage']"
                    ></p>
                    <p v-else>-</p>
                </div>
            </b-overlay>
        </b-modal>

        <!-- create post modal -->
        <CoPostEditor
            ref="postcreatemain"
            :user="{
                ...$store.state.me,
                ...$store.state.me.Profile,
            }"
            @created="addedPost"
            :disablePoll="false"
            :disableAttachments="false"
        />

        <!-- Guest alert modal -->
        <CoModal id="guestalert" ref="guestalert" :title="$t('messages.guest.notamemberyettitle')">
            <template v-slot:body>
                <CoText type="p1" class="p-2 m-0">{{ $t('messages.guest.notamemberyetbody') }}</CoText>
            </template>
            <template v-slot:footer>
                <div class="d-flex align-items-center justify-content-between">
                    <CoButton variant="blacksecondary" @click="stayOnPage()">
                        {{ $t('messages.guest.notmemberyetdiscardtitle') }}
                    </CoButton>
                    <CoButton variant="black" @click="goToMembershipPlan()">
                        {{ $t('messages.guest.notmemberyetconfirmtitle') }}
                    </CoButton>
                </div>
            </template>
        </CoModal>
        <CoPaywall ref="paywall" :feature="paywallFeature" :plan="$store.state.space.PlanSlug" />
    </div>
</template>
<style lang="less" scoped>
@content-top-padding-desktop: 4.75rem; //spacing between navbar and content

.spacer {
    width: 100%;
    height: calc(@content-top-padding-desktop + var(--header-height) + var(--main-alert-offset, 0px));
}

@media screen and (max-width: 992px) {
    .spacer {
        height: calc(var(--mobile-top-nav-height, var(--header-height)) + var(--main-alert-offset, 0px)) !important;
    }
}
</style>
<script>
import axios from 'axios';
import { isEmail } from 'validator';
import EventBus from '@/eventBus.js';
import IntroReminder from '@/components/old-components/IntroReminder';
import VueIntercom from 'vue-intercom';

import { get } from 'lodash';

import JSConfetti from 'js-confetti';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoAdminAlert from '../../components/Organisms/co-admin-alert/CoAdminAlert.vue';
import CoPostEditor from '../../components/Organisms/co-post-editor/coPostEditor.vue';
import CoTopNavBarWeb from '../../components/Organisms/co-top-nav-bar-web/CoTopNavBarWeb.vue';
import CoTopNavBarMobile from '../../components/Organisms/co-top-nav-bar-mobile/CoTopNavBarMobile.vue';
import CoIslandCreateButton from '../../components/Organisms/co-island-create-button/CoIslandCreateButton.vue';
import CoPaywall from '../../components/Organisms/co-paywall/CoPaywall.vue';

import setCustomColors from '../../customColors';
import { applyUserLocale, getPersistedUserLocale } from '@/utils/locale.js';

const jsConfetti = new JSConfetti();

export default {
    name: 'Main',
    components: {
        CoAdminAlert,
        IntroReminder,
        CoIslandCreateButton,
        CoTopNavBarWeb,
        CoPostEditor,
        CoEditor,
        CoPaywall,
    },
    data() {
        return {
            path: this.$router.currentRoute.path.split('/').join(' '),
            burgerMenuOpen: false,
            modalBlur: false,

            pauseUntil: {
                date: null,
                time: null,
                message: '',
            },
            notificationsPaused: false,

            customMenuItems: [],

            paywallFeature: 'none',
            // Track share-in-post context so we only record activity after a successful post creation.
            pendingShareInPostActivity: null,
        };
    },
    watch: {
        // set the path parameter for conditional styling
        $route(to, from) {
            // check if url params 'm' is equal to 'mobile' and set the isInMobile flag in store
            if (to.query.m === 'mobile') {
                this.$store.commit('SET_IS_IN_MOBILE', true);
            } else if (to.query.m === 'desktop') {
                this.$store.commit('SET_IS_IN_MOBILE', false);
            }

            this.checkIfNotificationsPaused();
            this.path = to.path.split('/').join(' ');
            this.modalBlur = false;

            this.burgerMenuOpen = false;
        },

        showUpgradeBar(val) {
            if (val) {
                // update --header-height var value
                const root = document.documentElement;
                root.style.setProperty('--header-height', '5.75rem');
            } else {
                const root = document.documentElement;
                root.style.setProperty('--header-height', '4.25rem');
            }
        },
    },

    computed: {
        showIslandButton() {
            if (!this.$store.state.isInMobile) {
                return false;
            }

            if (this.$route.path && this.$route.path.includes('/messenger')) {
                return false;
            }

            return true;
        },
        showUpgradeBar() {
            if (
                this.$store &&
                this.$store.state &&
                this.$store.state.space &&
                this.$store.state.space.PlanSlug === 'free'
            ) {
                return true;
            }
            return false;
        },
        me() {
            return this.$store.state.me;
        },
        query() {
            return this.$route.query.term;
        },
        isInMobile() {
            return get(this, '$store.state.isInMobile', false);
        },
        SupportURL() {
            if (
                this.$store &&
                this.$store.state &&
                this.$store.state.space &&
                typeof this.$store.state.space.SupportURL === 'string'
            ) {
                let url = this.$store.state.space.SupportURL.trim();
                if (isEmail(url)) {
                    url = `mailto:${url}`;
                } else {
                    url = url.startsWith('http') ? url : `https://${url}`;
                }
                return url.trim();
            }
            return null;
        },
    },
    beforeCreate() {
        this.$store
            .dispatch('getNewMessagesNumbers', null)
            .then((response) => {})
            .catch((error) => {
                console.info('getNewMessages', error);
            });
    },
    created() {
        if (this.showUpgradeBar) {
            // update --header-height var value
            const root = document.documentElement;
            root.style.setProperty('--header-height', '5.75rem');
        } else {
            const root = document.documentElement;
            root.style.setProperty('--header-height', '4.25rem');
        }
        this.getWelcomeChecklist();

        if (this.$route.query.m === 'mobile') {
            this.$store.commit('SET_IS_IN_MOBILE', true);
        } else if (this.$route.query.m === 'desktop') {
            this.$store.commit('SET_IS_IN_MOBILE', false);
        }

        if (
            this.$store &&
            this.$store.state &&
            this.$store.state.space &&
            !this.$router.currentRoute.path.startsWith('/admin')
        ) {
            const primaryColor = this.$store.state.space.PrimaryColor.replace(/\s/g, '');
            const secondaryColor = this.$store.state.space.SecondaryColor.replace(/\s/g, '');
            const textColor = this.$store.state.space.TextColor.replace(/\s/g, '');

            const colorData = [
                {
                    name: 'purple',
                    value: primaryColor,
                },
                {
                    name: 'red',
                    value: secondaryColor,
                },
                {
                    name: 'text',
                    value: textColor,
                },
            ];

            try {
                setCustomColors(colorData);
            } catch (error) {
                try {
                    setCustomColors([
                        {
                            name: 'primary',
                            value: '#5100ff',
                        },
                        {
                            name: 'red',
                            value: '#fd6969',
                        },
                        {
                            name: 'text',
                            value: '#212529',
                        },
                    ]);
                } catch (error2) {
                    console.log(error2);
                }
                console.log(error);
            }
        }

        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();

        const hour = date.getHours();
        const min = date.getMinutes();
        this.pauseUntil.date = `${year}-${month + 1}-${day}`;
        this.pauseUntil.time = `${hour}:${min}`;

        // listen to evenbus for topic confetti
        EventBus.$on('CONFETTI', (payLoad) => {
            jsConfetti.addConfetti();
        });
    },

    mounted() {
        // Reload effective permissions when the signed-in layout opens after login.
        this.getPermissionSettings();
        this.checkIfNotificationsPaused();
        this.$store.dispatch('getMe', null).then((response) => {
            this.setUserLanguage();
        });
        // event listener
        EventBus.$on(
            `MESSAGETOAST`,
            (payLoad) => {
                this.$coToast.showChatMessage(payLoad);
            },
            this
        );
        EventBus.$on(
            'STARTNEWPOST',
            (payLoad) => {
                if (!this.$store.state.permissions || this.$store.state.permissions['feed.post'] !== true) {
                    return;
                }
                const { content, shareActivity, cfg } = this.normalizeStartNewPostPayload(payLoad);
                this.pendingShareInPostActivity = shareActivity;
                this.startPostCreation(content, cfg);
            },
            this
        );
        EventBus.$on(
            'EDITPOST',
            (post = null, callback = null) => {
                this.editPost(post, callback);
            },
            this
        );

        EventBus.$on('GUESTALERT', (payLoad) => {
            this.$refs.guestalert.show();
        });
        EventBus.$on(
            'PAYWALL',
            (payload) => {
                this.handlePaywallEvent(payload);
            },
            this
        );
    },
    destroyed() {
        EventBus.$off('MESSAGETOAST');
        EventBus.$off('PAYWALL');
    },

    methods: {
        getPermissionSettings() {
            axios({
                method: 'GET',
                url: '/permissions/me',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((response) => {
                if (response && response.data) {
                    // Gateway returns effective decisions; absent actions are intentionally denied.
                    const permissions = (response.data.PermissionDecisions || []).reduce(
                        (decisions, decision) => ({ ...decisions, [decision.Action]: decision.Allowed === true }),
                        {}
                    );
                    this.$store.commit('SET_PERMISSIONS', permissions);
                }
            });
        },

        handlePaywallEvent(payload) {
            if (payload && typeof payload === 'object') {
                this.paywallFeature = payload.feature || payload.Feature || 'none';
            } else {
                this.paywallFeature = 'none';
            }

            const { paywall } = this.$refs;
            if (paywall) {
                paywall.show();
            }
        },
        stayOnPage() {
            this.$refs.guestalert.hide();
        },

        getWelcomeChecklist() {
            this.$store.dispatch('getWelcomeChecklist');
        },
        goToMembershipPlan() {
            this.$router.push('/account/plan');
            this.stayOnPage();
        },
        setUserLanguage() {
            const currentUserLanguage = get(this.$store.state.me, 'Language', '');
            const persistedUserLanguage = getPersistedUserLocale();

            if (currentUserLanguage) {
                applyUserLocale(this, currentUserLanguage);
                return;
            }

            if (persistedUserLanguage) {
                applyUserLocale(this, persistedUserLanguage);
            }

            if (!get(this.$store.state.me, 'ID', null)) {
                return;
            }

            axios({
                method: 'PUT',
                url: '/me/language',
                withCredentials: true,
                data: {
                    language: this.$i18n.locale,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$store.commit('GETME', response.data);
                        applyUserLocale(this, response.data.Language || this.$i18n.locale, { persist: true });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        goBack() {
            this.$router.go(-1);
        },
        emitEventToIntercom() {
            EventBus.$emit('intercomTrackEvent', {
                eventName: 'close-user-onboarding-modal',
            });
        },
        showPauseNotificationsModal() {
            this.$refs['pause-notificaions'].show();
        },
        showDeletePauseNotificationsModal() {
            this.$refs['delete-pause-notificaions'].show();
        },
        checkIfNotificationsPaused() {
            let now = new Date();
            now /= 1000;
            if (now < this.$store.state.me.NotificationsOffUntill) {
                this.notificationsPaused = true;
            } else {
                this.notificationsPaused = false;
            }
        },
        setNotificationPause() {
            const until = Date.parse(`${this.pauseUntil.date} ${this.pauseUntil.time}`) / 1000; // todo fix for utc
            const data = { pause: until, message: this.pauseUntil.message.replace(/<p><\/p>/g, '<br>') };
            axios({
                method: 'POST',
                url: '/me/pause-notifications',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$store.dispatch('getMe', null).then((response) => {
                        this.checkIfNotificationsPaused();
                    });
                })
                .catch((error) => {
                    console.info(error);
                });
        },

        removeNotificationPause() {
            axios({
                method: 'DELETE',
                url: '/me/pause-notifications',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$store.dispatch('getMe', null).then((response) => {
                        this.checkIfNotificationsPaused();
                    });
                })
                .catch((error) => {
                    console.info(error);
                });
        },

        // get custom menu items
        getCustomMenuItems() {
            axios
                .get('/dashboard/custom-menu-options/list')
                .then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.customMenuItems = response.data;
                    } else {
                        this.customMenuItems = [];
                    }
                })
                .catch((error) => {
                    this.customMenuItems = [];
                    console.log(error);
                });
        },

        // start post creation
        startPostCreation(content = '', cfg = {}) {
            if (content) {
                this.$refs.postcreatemain.clearDraft();
            }
            this.$refs.postcreatemain.show({
                Text: content,
                ...cfg,
            });
        },
        // edit post
        editPost(post = null, callBack = null) {
            if (!post) return;
            // map post structure to editor structure
            const postToEdit = {
                ...get(post, 'object', {}),
                Files: get(post, 'object.Images', []).map((image) => ({ url: image.ImageURL })),
                wasUpdated: true,
            };
            this.$refs.postcreatemain.show(postToEdit, true, callBack);
        },

        // Record share activity after CoPostEditor has successfully created the post.
        addedPost() {
            if (this.pendingShareInPostActivity) {
                this.recordShareInPostActivity(this.pendingShareInPostActivity);
                this.pendingShareInPostActivity = null;
            }
        },
        normalizeStartNewPostPayload(payload) {
            if (payload && typeof payload === 'object') {
                const content = typeof payload.content === 'string' ? payload.content : '';
                const shareActivity = payload.shareActivity || null;
                const cfg = payload.cfg || {};
                return { content, shareActivity, cfg };
            }

            return {
                content: typeof payload === 'string' ? payload : '',
                shareActivity: null,
                cfg: {},
            };
        },
        recordShareInPostActivity(shareActivity) {
            const route = this.$route || null;
            if (!route) {
                return;
            }
            const location = route.path || window.location.pathname;
            const fullPath = route.fullPath || `${window.location.pathname}${window.location.search}`;

            axios
                .post('/me/activity/funnel', {
                    funnel: 'share_activity',
                    step: 'feature_click',
                    feature_key: 'share_in_post',
                    location,
                    full_path: fullPath,
                    parameters: {
                        contentType: shareActivity.contentType || null,
                        contentSlug: shareActivity.contentSlug || null,
                        contentID: shareActivity.contentID || null,
                        contentURL: shareActivity.contentURL || null,
                    },
                })
                .catch((error) => {
                    console.error('Failed to record share activity', error);
                });
        },
    },
};
</script>
